// src/hooks/useSharedFuelData.js
import { useState, useEffect } from 'react';

// Helper function to generate initial *static* sparkline data
const generateInitialStaticSparklineData = (baseValue, volatility = 5) => {
    const data = [];
    let currentValue = baseValue;
    for (let i = 0; i < 10; i++) { // Generate 10 data points
        currentValue += (Math.random() - 0.5) * volatility;
        data.push(parseFloat(Math.max(0, currentValue).toFixed(2)));
    }
    return data;
};

// Helper function to provide default fuel data
const getDefaultFuelData = () => [
    {
        id: 1,
        price: 1189.12,
        fuelType: 'Premium Motor Spirit (PMS)',
        link: 'https://www.nigerianstat.gov.ng/elibrary/search/Premium Motor Spirit',
        tooltipData: 'avg price/litre. PMS (January-2025)',
        sparklineData: generateInitialStaticSparklineData(1189.12),
        sparklineColor: '#007bff',
    },
    {
        id: 2,
        price: 1447.62,
        fuelType: 'Automotive Gasoline Oil (AGO)',
        link: 'https://www.nigerianstat.gov.ng/elibrary/search/Diesel',
        tooltipData: 'avg price/litre. AGO (January-2025)',
        sparklineData: generateInitialStaticSparklineData(1447.62),
        sparklineColor: '#28a745',
    },
    {
        id: 3,
        price: 2056.38,
        fuelType: 'National Household Kerosene (NHK)',
        link: 'https://www.nigerianstat.gov.ng/elibrary/search/Kerosene',
        tooltipData: 'avg price/litre. NHK (January-2025)',
        sparklineData: generateInitialStaticSparklineData(2056.38),
        sparklineColor: '#ffc107',
    },
    {
        id: 4,
        price: 7177.27,
        fuelType: 'Liquefied Petroleum Gas 5Kg (LPG)',
        link: 'https://www.nigerianstat.gov.ng/elibrary/search/LPG',
        tooltipData: 'avg price. LPG (January-2025)',
        sparklineData: generateInitialStaticSparklineData(7177.27, 100),
        sparklineColor: '#dc3545',
    },
];

// Helper function to generate a random hex color (optional, for initial data)
function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


const useSharedFuelData = () => {
    const [sharedFuelData, setSharedFuelData] = useState(() => {
        const savedFuelData = localStorage.getItem('fuelData');
        if (savedFuelData) {
            try {
                const parsedData = JSON.parse(savedFuelData);
                // Ensure each item in saved data has sparklineData and sparklineColor, generate if missing
                // AND ensure price is a number
                return parsedData.map(item => ({
                    ...item,
                    price: parseFloat(item.price), // <--- Added this line
                    sparklineData: item.sparklineData && item.sparklineData.length > 0 ? item.sparklineData : generateInitialStaticSparklineData(item.price),
                    sparklineColor: item.sparklineColor || getRandomColor(), // Generate a random color if missing
                }));
            } catch (e) {
                console.error("Failed to parse fuel data from localStorage:", e);
                return getDefaultFuelData(); // Return default data on parsing error
            }
        }
        return getDefaultFuelData(); // Return default data if nothing in localStorage
    });

    const updateSharedFuelData = (newFuelData) => {
        // Ensure prices are numbers before saving
        const dataToSave = newFuelData.map(item => ({
            ...item,
            price: parseFloat(item.price) // Ensure price is a number before saving
        }));
        setSharedFuelData(dataToSave);
    };


    // Save to localStorage whenever sharedFuelData changes
    useEffect(() => {
        // Ensure prices are numbers before saving to localStorage
        const dataToSave = sharedFuelData.map(item => ({
            ...item,
            price: parseFloat(item.price)
        }));
        localStorage.setItem('fuelData', JSON.stringify(dataToSave));
    }, [sharedFuelData]);


    return { sharedFuelData, updateSharedFuelData }; // Removed updateFuelPrice for simplicity if not used elsewhere
};

export default useSharedFuelData;